import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import Widgets from '@/components/Dashboard/Widgets/Widget/Widget.vue';
import WidgetConfig from '@/components/Dashboard/Widgets/WidgetConfig/WidgetConfig.vue';
import { WidgetData } from '@/components/Dashboard/Widgets/types/Widget';
import Widget from '@/components/Dashboard/Widgets/Widget/Widget';

@Component({
    components: {
        Widgets,
        WidgetConfig
    }
})
export default class Dashboard extends Vue {

    private widgets: WidgetData[] = [];
    private today = moment().locale('ja'); // グローバル設定に影響しないようインスタンスにロケール設定する
    private showConfigModal = false
    private widgetIndex!: number

    private camelWidgetData: WidgetData = {
        id: '',
        title: '',
        config: '',
        component: ''
    }

    private get currentYear(): string {
        return this.today.format("YYYY");
    }

    private get currentMonth(): string{
        return this.today.format("M");
    }

    private get currentDay(): string{
        return this.today.format("D");
    }

    private get currentWeek(): string{
        return this.today.format("dddd");
    }

    get refs():any {
        return this.$refs;
    }

    private async created() {
        this.getWidgets();
        this.$eventHub.$on('closeConfig', () => {
            this.showConfigModal = false
        })
    }

    private getWidgets() {
        this.$apiClient.doRequest('get', `/admin/widget_instances`).then((ret) => {
            this.widgets = ret;
        });
    }

    private openConfig(camelWidgetData: WidgetData, widgetIndex: number) {
        this.camelWidgetData = camelWidgetData
        this.showConfigModal = true
        this.widgetIndex = widgetIndex
    }

    private saveConfig(widgetData: WidgetData) {
        const widget= this.widgets.find(widget => widget.id == widgetData.id)
        const widgetId = widget ? widget.id : '';
        (this.refs[widgetId][0] as InstanceType<typeof Widget>).closeConfig(widgetData).then()
    }
}